import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { ProductDataSheet } from "../../Model/Dto/ProductDataSheet";
import { ProductReportingService } from "../../Services/productreporting.service";
import { LoginService } from "../../Services/login.service";
import { custom } from "devextreme/ui/dialog";
import { SystemService } from "../../Services/system.service";



@Component({
    selector: "datasheetManagement",
    templateUrl: "datasheetManagement.component.html",
    standalone: false
})
export class DatasheetManagementComponent implements OnInit {
  pages = [];
  dataSource = new Array<ProductDataSheet>();
  dataSourceBackups = new Array<ProductDataSheet>();
  _customerId: string = "";
  constructor(public loginService: LoginService, public translate: TranslateService,
    public productReportingService: ProductReportingService, public systemService: SystemService) {

    this.restoreReportFromBackup = this.restoreReportFromBackup.bind(this);
  }
  @Input()
  set customerId(val: string) {
    this._customerId = val;
    this.productReportingService.getFiles(this._customerId).subscribe((result: ProductDataSheet[]) => {
      this.dataSource = result;
    });
    this.productReportingService.getFiles(this._customerId, true).subscribe((result: ProductDataSheet[]) => {
      this.dataSourceBackups = result;
    });
  }
  get customerId(): string {
    return this._customerId;
  }

  ngOnInit(): void {
    let pageDatasheetTableTemplate = "";
    pageDatasheetTableTemplate = this.translate.instant("Produktdatenblätter");
    let pageDatasheetBackupTemplate = "";
    pageDatasheetBackupTemplate = this.translate.instant("Backups");

    this.pages = [
      { id: 1, title: pageDatasheetTableTemplate, template: "datasheetTableTemplate" },
      { id: 2, title: pageDatasheetBackupTemplate, template: "datasheetBackupTemplate" }
    ];
  }

  isManager(): boolean {
    if (this.loginService.currentUser.currentClaim == "USER") return false;
    return true;
  }
  onDeleteClicked(event) {
    this.productReportingService.deleteReport(event.data).subscribe((result: boolean) => {
      if (result == true) {
        let i = 1;
      }

    });
  }
  onSaving(event) {
    let e = event;
    if (event.changes[0]) {
      let change = event.changes[0];
      if (change.type == "update") {
        let data = new ProductDataSheet();
        data = change.key;
        data.nameNew = change.data.name;
        this.productReportingService.renameReport(data).subscribe((result: boolean) => {
          this.productReportingService.getFiles(this._customerId).subscribe((result: ProductDataSheet[]) => {
            this.dataSource = result;
          });
        });
        e.cancel = true;
      }
    }
  }

  async restoreReportFromBackup(event) {
    var data = event.row.data;

    let txtYes: string;
    let txtNo: string;
    let txtMsg: string;
    let txtTitle: string;

    this.translate.get("Ja").subscribe((text: string) => {
      txtYes = text;
    });
    this.translate.get("Nein").subscribe((text: string) => {
      txtNo = text;
    });
    this.translate.get("txtRestoreReportBackupText").subscribe((text: string) => {
      txtMsg = text;
    });
    this.translate.get("txtRestoreReportBackupTitle").subscribe((text: string) => {
      txtTitle = text;
    });

    let myDialog = custom({
      title: txtTitle,
      messageHtml: txtMsg,
      buttons: [{
        text: txtYes,
        onClick: (e) => {
          return { buttonText: true }
        }
      },
      {
        text: txtNo,
        onClick: (e) => {
          return { buttonText: false }
        }
      }
      ]
    });

    myDialog.show().then(async (dialogResult) => {
      if (dialogResult.buttonText == true) {
        var restoredFilename = await this.productReportingService.restoreReportFromBackup(data.customerId, data.name);

        if (restoredFilename && restoredFilename.value !== "") {
          this.systemService.notifyInfo(this.translate.instant('Report {{reportname}} wurde aus Backup wiederhergestellt.', { reportname: restoredFilename.value }));
          this.productReportingService.getFiles(this._customerId).subscribe((result: ProductDataSheet[]) => {
            this.dataSource = result;
          });
        } else {
          this.systemService.notifyInfo(this.translate.instant('Report konnte nicht wiederhergestellt werden.'));
        }
      }
    });

    
  }

}



